import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn, PaletteUtils } from '@shared/utils';
import { Icon, Text } from '@shared/widgets';
import ExternalLinkIcon from '@assets/icons/external-link.svg';
import ChevronIcon from '@assets/icons/chevron.svg';

const REWARDS_URL = 'https://www.vcfc.com/corporate-rewards-marketplace';

interface WebsiteProps {
  className?: string;
}

export const Website = (props: WebsiteProps) => {
  const { t } = useTranslation('rewards');

  return (
    <section
      className={cn(
        'flex items-center justify-center bg-white p-6 dark:bg-soft-black',
        PaletteUtils.isVcfcPalette && 'rounded-xl dark:border dark:border-gray-black',
        props.className,
      )}
    >
      <Link
        className={cn(
          'flex w-full max-w-xl items-center gap-3 rounded-sm bg-primary px-6 py-4 transition-opacity',
          'hover:opacity-90',
          'max-md:px-4 max-md:py-3',
          PaletteUtils.isVcfcPalette && 'rounded-xl',
        )}
        to={REWARDS_URL}
        target='_blank'
        rel='noreferrer'
      >
        <Icon icon={<ExternalLinkIcon />} color='white' />
        <Text className='flex-1' weight='medium' color='white'>
          {t('website.link')}
        </Text>
        <Icon className='rotate-180' icon={<ChevronIcon />} color='white' />
      </Link>
    </section>
  );
};
